import { render } from "./NavigationOverlay.vue?vue&type=template&id=127c810b&scoped=true"
import script from "./NavigationOverlay.vue?vue&type=script&lang=js"
export * from "./NavigationOverlay.vue?vue&type=script&lang=js"

import "./NavigationOverlay.vue?vue&type=style&index=0&id=127c810b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-127c810b"]])

export default __exports__